import { computed, effect, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, tap } from 'rxjs';
import { LocalstorageService } from './localstorage.service';
import { APP } from '@libs/interfaces';

@Injectable({
  providedIn: 'root',
})
export class RoutesService {
  private url = signal(new URL(window.location.href));
  private pathName = computed(() => this.url().pathname.toLowerCase());
  route_base = signal('');
  route = signal('');

  constructor(
    private router: Router,
    private ls: LocalstorageService,
  ) {
    effect(() => {
      if (this.route_base() != this.ls.app_selected())
        switch (this.route_base()) {
          case 'landing':
            this.ls.app = APP.LANDING;
            break;
          case 'app':
            this.ls.app = APP.APP;
            break;
          case 'casino':
            this.ls.app = APP.CASINO;
            break;
          case 'sports':
            this.ls.app = APP.SPORTS;
            break;
          default:
            break;
        }
    });
  }

  /**
   * Initializes the route service, analyzes the first route, and sets up route navigation based on the selected app.
   */
  onInit() {
    this.analizeFirstRoute();
    const app = this.ls.app_selected();

    switch (app) {
      case APP.APP:
        this.route_base.set('app');
        this.route.set('/app');
        this.router.navigate(['']);
        setTimeout(() => this.router.navigateByUrl('/app'), 1000);
        break;
      case APP.CASINO:
        this.route_base.set('casino');
        this.route.set('/casino');
        this.router.navigate(['']);
        setTimeout(() => this.router.navigateByUrl('/casino'), 1000);
        break;
      case APP.SPORTS:
        this.route_base.set('sports');
        this.router.navigate(['']);
        setTimeout(() => this.router.navigateByUrl('/sports'), 1000);
        break;
      default:
        this.route_base.set('landing');
        this.route.set('/');
        this.router.navigate(['']);
        setTimeout(() => this.router.navigateByUrl('/'), 1000);
        break;
    }
    setTimeout(() => {
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          map((event: NavigationEnd) => event.url),
          tap(url => {
            this.route.set(url);
            const splitted = url.split('/');
            const res = splitted[1] || 'landing';
            this.route_base.set(res);
          }),
        )
        .subscribe();
    }, 1000);
  }

  /**
   * Analyzes the first route to determine the selected app based on the URL path.
   */
  analizeFirstRoute() {
    if (this.pathName().includes('app')) {
      this.ls.app = APP.APP;
    } else if (this.pathName().includes('casino')) {
      this.ls.app = APP.CASINO;
    } else if (this.pathName().includes('sports')) {
      this.ls.app = APP.SPORTS;
    }
  }
}
